<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        v-if="$canEdit"
        type="primary"
        class="filter-item"
        size="small"
        @click="handleCreate"
        >新增</el-button
      >

      <el-input
        v-model="listQuery.name"
        placeholder="配置名称"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-select
        v-model="listQuery.notify_type"
        placeholder="通知类型"
        clearable
        style="width: 120px"
        class="filter-item"
        size="small"
      >
        <el-option label="邮箱" value="email" />
        <el-option label="短信" value="sms" />
        <el-option label="微信" value="wechat" />
        <el-option label="钉钉" value="dingtalk" />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        clearable
        style="width: 90px"
        class="filter-item"
        size="small"
      >
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button
        type="primary"
        class="filter-item"
        size="small"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      size="small"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="配置名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column label="通知类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.notify_type === 'email'" type="primary"
            >邮箱</el-tag
          >
          <el-tag v-else-if="scope.row.notify_type === 'sms'" type="success"
            >短信</el-tag
          >
          <el-tag v-else-if="scope.row.notify_type === 'wechat'" type="info"
            >微信</el-tag
          >
          <el-tag
            v-else-if="scope.row.notify_type === 'dingtalk'"
            type="warning"
            >钉钉</el-tag
          >
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="通知值" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.notify_value || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="170" align="center">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="170" align="center">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.updated_at }}</span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="$canEdit"
        label="操作"
        align="center"
        width="250"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 详情 -->
    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="配置名称" prop="name">
          <el-input type="text" v-model="form.name" clearable />
        </el-form-item>

        <el-form-item label="通知类型" prop="notify_type">
          <el-select
            v-model="form.notify_type"
            placeholder="请选择"
            clearable
            style="width: 100%"
          >
            <el-option label="邮箱" value="email" />
            <el-option label="短信" value="sms" />
            <el-option label="微信" value="wechat" />
            <el-option label="钉钉" value="dingtalk" />
          </el-select>
        </el-form-item>

        <el-form-item label="通知值" prop="notify_value">
          <el-input type="text" v-model="form.notify_value" clearable />
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        name: '',
        notify_type: '',
        status: '',
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        create: '新增',
        update: '修改',
      },
      form: {
        id: null,
        name: '',
        notify_type: '',
        notify_value: '',
        status: '',
      },
      rules: {
        name: [
          { required: true, message: '配置名称不能为空', trigger: 'change' },
        ],
        notify_type: [
          { required: true, message: '通知类型不能为空', trigger: 'change' },
        ],
        notify_value: [
          { required: true, message: '通知值不能为空', trigger: 'change' },
        ],
      },
      btnLoading: false,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/notification-config/list',
        method: 'get',
        params: this.listQuery,
      })
        .then((response) => {
          this.list = response.data.data
          this.total = response.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        id: null,
        name: '',
        notify_type: '',
        notify_value: '',
        status: '',
      }
      this.btnLoading = false
    },
    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate() //清除校验结果
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = Object.assign({}, row)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate() //清除校验结果
      })
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/notification-config/store',
            method: 'post',
            data: this.form,
          })
            .then(() => {
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .catch((err) => {
              console.log(err)
              this.btnLoading = false
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该通知配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request({
          url: '/api/backend/notification-config/delete',
          method: 'post',
          data: { id: row.id },
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
          })
          this.getList()
        })
      })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
